module.exports = __webpack_public_path__ + "static/media/TA271.150f72d4.png";